import { usePreferences } from 'context/preferences/PreferencesContext'

export const featureFlagService = () => {
  const { preferences, isLoading } = usePreferences()

  const getFeatureFlag = (flagName: string, defaultValue = false) =>
    preferences?.feature_flags?.[flagName]?.enabled ?? defaultValue

  const enableCompanyEmailExtensionSettings = getFeatureFlag(
    'enable_company_email_extension_settings'
  )
  const enableUserNotificationPreferences = getFeatureFlag(
    'enable_user_notification_preferences'
  )

  const shouldShowMenuSize = getFeatureFlag('show_menu_size')
  const enableInstagremData = getFeatureFlag('enable_instagram_data')
  const enableInstagramPercentile = getFeatureFlag(
    'enable_instagram_percentiles'
  )
  const shouldShowMenu = getFeatureFlag('show_menu_column')
  const shouldShowReputationData = getFeatureFlag('reputation_data')
  const shouldShowDoorMenu = getFeatureFlag('show_door_menu_column')
  const enableCnUTable = getFeatureFlag('enable_cnu_table')
  const enableK12Table = getFeatureFlag('enable_k12_table')
  const enableActivityV2 = getFeatureFlag('enable_activity_v2')
  const enableRestaurantsCountryFilter = getFeatureFlag(
    'enable_restaurants_country_filter'
  )
  const enableContactRequests = getFeatureFlag('enable_contact_requests')
  const enableChainsListV2 = getFeatureFlag('chains_list_v2')
  const enableTagsSort = getFeatureFlag('enable_tags_sort')
  const enableCampaigns = getFeatureFlag('enable_campaigns')
  const enableHospitals = getFeatureFlag('enable_hospitals_table')
  const enableNursingHomes = getFeatureFlag('enable_nursing_homes_table')
  const enableRebates = getFeatureFlag('enable_rebates')
  const enableEmailIntegration = getFeatureFlag('enable_email_integration')
  const enableOppsAttrsServicesAtmosOffersHours = getFeatureFlag(
    'enable_opps_attrs_services_atmos_offers_hours'
  )
  const enableLodging = getFeatureFlag('enable_lodging_table')
  const enableConvenience = getFeatureFlag('enable_convenience_table')
  const enablePushToSalesforce = getFeatureFlag('enable_push_to_salesforce')
  const enableHQStateColumn = getFeatureFlag('enable_hq_state_column')
  const enableContactCredits = getFeatureFlag('enable_contact_credits')
  const enableNewImportTool = getFeatureFlag('enable_new_import_tool')
  const enableIntercom = getFeatureFlag('enable_intercom')
  const enableSearch = getFeatureFlag('enable_search')
  const automationsPageEnabled = getFeatureFlag('automations_page_enabled')
  const enabledReportDeals = getFeatureFlag('enabled_report_deals')
  const enableReminders = getFeatureFlag('enable_reminders')
  const enabledReportDoors = getFeatureFlag('enabled_report_doors')
  const enabledReportChains = getFeatureFlag('enabled_report_chains')
  const enableSSO = getFeatureFlag('enable_sso')
  const enableDashboardReports = getFeatureFlag('enable_dashboard_reports')
  const enableNewCompanyPage = getFeatureFlag('enable_new_company_page')
  const enableSamples = getFeatureFlag('enable_samples')
  const enableMobileApp = getFeatureFlag('enable_mobile_app')
  const enableSyndigoIntegration = getFeatureFlag('enable_syndigo_integration')
  const enableDocumentLibrary = getFeatureFlag('enable_document_library')
  const enableImporterWizard = getFeatureFlag('enable_import_wizard')

  return {
    shouldShowMenuSize,
    enableInstagremData,
    enableInstagramPercentile,
    shouldShowMenu,
    shouldShowReputationData,
    shouldShowDoorMenu,
    enableCnUTable,
    enableK12Table,
    enableActivityV2,
    enableRestaurantsCountryFilter,
    enableContactRequests,
    enableChainsListV2,
    enableTagsSort,
    enableCampaigns,
    enableHospitals,
    enableNursingHomes,
    enableRebates,
    enableEmailIntegration,
    enableOppsAttrsServicesAtmosOffersHours,
    enableLodging,
    enableConvenience,
    enablePushToSalesforce,
    enableHQStateColumn,
    enableContactCredits,
    enableNewImportTool,
    enableCompanyEmailExtensionSettings,
    enableUserNotificationPreferences,
    enableIntercom,
    enableSearch,
    automationsPageEnabled,
    enabledReportDeals,
    enableReminders,
    enabledReportDoors,
    enabledReportChains,
    enableSSO,
    enableDashboardReports,
    enableNewCompanyPage,
    enableSamples,
    enableSyndigoIntegration,
    isLoading,
    enableMobileApp,
    enableDocumentLibrary,
    enableImporterWizard,
  }
}

export type FeatureFlags = Omit<
  ReturnType<typeof featureFlagService>,
  'isLoading'
>
